export const HEADER_CONTACT_OPEN = 'HEADER_CONTACT_OPEN';
export const HEADER_CONTACT_CLOSE = 'HEADER_CONTACT_CLOSE';

export const openContactDropDown = () => ({
  type: HEADER_CONTACT_OPEN
});

export const closeContactDropDown = () => ({
  type: HEADER_CONTACT_CLOSE
});
